import Characteristics from "~/components/product/ProductDescription/Characteristics"
import Description from "~/components/product/ProductDescription/Description"
import Reviews from "~/components/product/ProductDescription/Reviews"
import { ProductDetailsPage } from "@decocms/apps-commerce/types"
import ScrollToTopOnClickSeeMore from "~/components/product/ProductDescription/ScrollToTopOnClickSeeMore"
import type { SanitizedDescription } from "~/sdk/sanitizeProductHtml"

export interface Props {
    /**
     * @title Integração
     */
    page: ProductDetailsPage | null
    /**
     * HTMLs já sanitizados no servidor pelo loader da section
     * (`setup/section-loaders.ts` → `~/sdk/sanitizeProductHtml`).
     * @ignore
     */
    sanitized?: SanitizedDescription
}

export default function ProductDescription({ page, sanitized }: Props) {
    if (!page) {
        return null
    }

    const { description: productDescription = '', characteristics = '', otherSpecs = '' } = sanitized ?? {}

    return (
        <>
            <div className='relative bg-neutral-200'>
                <input type='checkbox' id='description-dropdown' className='hidden peer' />
                <div className='group absolute z-[1] bottom-0 py-5 text-center w-full text-base text-white bg-[linear-gradient(0deg,white,transparent)]'>
                    <label
                        className='px-4 py-1 rounded-full cursor-pointer bg-red-wine'
                        htmlFor='description-dropdown'
                        id='see-more'
                    >
                        <span className='peer-checked:group-[]:hidden inline'>Ver mais</span>
                        <span className='peer-checked:group-[]:inline hidden'>Ver menos</span>
                    </label>
                </div>
                <div
                    id='description'
                    className='flex flex-col h-full gap-12 px-4 mx-auto overflow-hidden md:flex-row max-w-[1770px] min-[1025px]:px-12 pt-[70px] max-h-[540px] peer-checked:max-h-full peer-checked:pb-16'
                >
                    <div className='w-full md:w-1/2'>
                        <Description description={productDescription} />
                        <hr className='w-full mt-10 mb-[30px] border-t border-[#abababaa]' />
                        <Characteristics innerText={characteristics + otherSpecs} />
                    </div>
                    <hr className='h-auto border-white border-x' />
                    <Reviews
                        category={page.product.category?.split('>')?.at(-1) ?? ''}
                        inProductGroupWithID={page.product.inProductGroupWithID ?? ''}
                        name={page.product.name ?? ''}
                        image={page.product.image?.[0].url ?? ''}
                    />
                </div>
            </div>
            <ScrollToTopOnClickSeeMore />
        </>
    )
}
